module.exports = "<div id=\"map\" class=\"mat-elevation-z8\">\n    <!--<app-navigator [(address)]=\"address\"></app-navigator>-->\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/map/map.component.html
// module id = ./src/app/shared/components/map/map.component.html
// module chunks = main